import { DatePicker, Form } from 'antd';

import { RangeDateTplType } from '../types/tplTypes';

const { RangePicker }: any = DatePicker;
export const RangePickerTpl = ({ data }: { data: RangeDateTplType }) => {
  const { componentProps = {}, placeholder } = data;
  if (placeholder) {
    componentProps.placeholder = placeholder;
  }
  return (
    <Form.Item
      name={data.id}
      label={data?.label}
      {...(data.formItemProps || {})}
    >
      <RangePicker
        format={data.format || 'YYYY-MM-DD'}
        allowClear
        style={{ minWidth: 240 }}
        allowEmpty={[true, true]}
        {...(data.componentProps || {})}
      />
    </Form.Item>
  );
};
